// extracted by mini-css-extract-plugin
export default {"bottomBox":"index_bottomBox__yQivz","withNotePanel":"index_withNotePanel__n6nEq","questionNavigation":"index_questionNavigation__u2Mtz","footer":"index_footer__9GMap"};